import type { Hit } from "instantsearch.js";
import type { SendEventForHits } from "instantsearch.js/es/lib/utils";
import { Highlight } from "react-instantsearch";
import { getExcerptParts } from "../excerpt";
import type { SearchIndexHit } from "../types";

export default function AlgoliaHit({
	hit,
	sendEvent,
}: {
	hit: Hit<SearchIndexHit>;
	sendEvent: SendEventForHits;
}) {
	const parts = getExcerptParts(hit);
	let offset = 0;
	return (
		<article className="search-result-item">
			<h2 className="search-result-title">
				<a
					className="stretched-link"
					href={hit.url}
					onClick={() => sendEvent("click", hit, "Search result clicked")}
				>
					<Highlight hit={hit} attribute="title" />
				</a>
			</h2>
			{parts.length > 0 ? (
				<p className="mb-0">
					{parts.map((part) => {
						const key = offset;
						offset += part.value.length;
						// Keep an owned element when Google Translate replaces its text node.
						return part.isHighlighted ? (
							<mark key={key}>{part.value}</mark>
						) : (
							<span key={key}>{part.value}</span>
						);
					})}
				</p>
			) : null}
			{hit.tags.length > 0 ? (
				<ul className="m-0 flex list-none flex-wrap gap-2 p-0">
					{hit.tags.map((tag) => (
						<li className="tag tag-light px-2! py-1!" key={tag}>
							{tag}
						</li>
					))}
				</ul>
			) : null}
		</article>
	);
}
